(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.site-header');
    if (!root) return;

    var toggle = root.querySelector('[data-mobile-nav-toggle]');
    var closeBtn = root.querySelector('[data-mobile-nav-close]');
    var drawer = root.querySelector('#MobileNavDrawer');
    var backdrop = root.querySelector('[data-mobile-nav-backdrop]');
    if (!toggle || !drawer || !backdrop) return;

    var TRANSITION_MS = 280;
    var hideTimer = null;

    function getFocusable() {
      return Array.from(drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      ));
    }

    function openDrawer() {
      window.clearTimeout(hideTimer);
      drawer.hidden = false;
      backdrop.hidden = false;
      // Force reflow so the transition runs from the hidden state
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('no-scroll');
      document.addEventListener('keydown', onKeyDown);
      // Move focus to first focusable element inside drawer (WCAG 2.4.3)
      var focusable = getFocusable();
      if (focusable.length) window.setTimeout(function () { focusable[0].focus(); }, 50);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKeyDown);
      // Restore focus to the toggle button (WCAG 2.4.3)
      toggle.focus();
      hideTimer = window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
          backdrop.hidden = true;
        }
      }, TRANSITION_MS);
    }

    function onKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeDrawer();
        return;
      }
      // Focus trap inside drawer (WCAG 2.1.2)
      if (e.key === 'Tab') {
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    // Close drawer if user resizes back to desktop while it's open
    var mql = window.matchMedia('(min-width: 769px)');
    var onMatchChange = function (e) {
      if (e.matches && drawer.classList.contains('is-open')) closeDrawer();
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', onMatchChange);
    } else if (mql.addListener) {
      mql.addListener(onMatchChange);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
